// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"392b10a0","239":"6616f0bd","455":"e4aed4f9"}[chunkId] + ".chunk.js";
};